// extracted by mini-css-extract-plugin
export default {"reviewCard":"ReviewCard_reviewCard__r2H5j"};